import React, { useState } from "react";
import { useBetSlip } from "../providers/BetSlipProvider";
import { loadBetSlipFromBookingCode } from "../shared/utils/bet-slip";
import { useI18n } from "../providers/I18nProvider";
import CharacterKeyboard from "./CharacterKeyboard";

const EmptyState = () => {
  const { config } = useBetSlip();
  const { t } = useI18n();
  const [bookingCode, setBookingCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  const handleLoadBookingCode = async () => {
    if (bookingCode.trim() && !isLoading) {
      setIsLoading(true);
      setError(false);

      try {
        await loadBetSlipFromBookingCode({
          code: bookingCode.trim(),
          brandId: config.brand.id,
        });
        setBookingCode("");
        setIsKeyboardVisible(false);
      } catch (err) {
        console.error("Failed to load bet slip:", err);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleInputInteract = () => {
    if (config.kiosk.isKiosk && !isKeyboardVisible) {
      setIsKeyboardVisible(true);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center px-2 pt-5 pb-2.5 space-y-6">
      {/* Booking Code Input */}
      <div className="w-full space-y-2">
        <div className="flex gap-4">
          <input
            type="text"
            value={bookingCode}
            onChange={(e) => setBookingCode(e.target.value)}
            placeholder={t("BookingCode")}
            className="flex-1 px-3 py-[8px] border border-input-border bg-input-bg text-input-text border-input-border focus:outline-none placeholder:text-input-placeholder rounded-md text-md"
            disabled={isLoading}
            readOnly={config.kiosk.isKiosk}
            onFocus={handleInputInteract}
            onClick={handleInputInteract}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleLoadBookingCode();
              }
            }}
          />
          <button
            onClick={handleLoadBookingCode}
            className="px-4 py-2 w-[100px] bg-btn-load-bet text-btn-load-bet-text text-sm rounded-md transition-colors"
            disabled={!bookingCode.trim() || isLoading}
            type="button"
          >
            {t("LoadBetButton")}
          </button>
        </div>
        {error && (
          <div className="text-md text-red-600 text-left">
            {t("InvalidBetslipCode")}
          </div>
        )}
        {config.kiosk.isKiosk && isKeyboardVisible && (
          <CharacterKeyboard
            value={bookingCode}
            onValueChange={setBookingCode}
            onClose={() => setIsKeyboardVisible(false)}
          />
        )}
      </div>
      {/* Empty Receipt Icon */}
      <div className="pt-[35px]">
        <i className="au-m-ico-c au-i-new-empty-betslip text-[70px] text-betslip-empty-icon"></i>
      </div>

      {/* Title */}
      <h3 className="text-20 text-body-text">
        {t("BetSlipWidgetNoSelectionsExplanationHeader")}
      </h3>

      <p className="text-md text-primary pb-8 max-w-[190px]">
        {t("BetSlipWidgetNoSelectionsExplanationText")}
      </p>
    </div>
  );
};

export default EmptyState;
